<template>
    <div
        :class="rootClass"
        :data-aos="layout === 'page' ? 'fade-left' : undefined"
        :data-aos-duration="layout === 'page' ? '1500' : undefined"
    >
        <div class="d-flex flex-column flex-grow-1">
            <template v-if="!hideHeading">
                <component :is="headingTag" class="card-title mb-2">{{
                    titleText
                }}</component>
                <p class="card-subtitle mb-4 mb-md-0">
                    Escolha um nome e uma periodicidade de renovação de assinatura
                    para este plano.
                </p>
                <hr class="page-card__divider mb-md-6" />
            </template>

            <div class="row plan-form-fields">
                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld"
                            >Nome do Plano<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <input
                            type="text"
                            required
                            class="inputd mb-1"
                            v-model="nomePlano"
                            placeholder="Plano Mensal - 2º Semestre"
                        />
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld" for="valorPlanoNew"
                            >Valor<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <input
                            id="valorPlanoNew"
                            type="text"
                            required
                            class="inputd mb-1"
                            v-model="valorPlano"
                            placeholder="R$ 99,99"
                            @input="formatarValor"
                        />
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld"
                            >Frequência de Renovação<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <select
                            required
                            class="inputd mb-1"
                            v-model="frequenciaRenovacao"
                        >
                            <option value="" disabled selected>
                                Selecione a frequência
                            </option>
                            <option value="1">Mensal</option>
                            <option value="2">Semestral</option>
                            <option value="3">Trimestral</option>
                            <option value="4">Anual</option>
                        </select>
                        <small
                            >Escolha a frequência de renovação do plano.</small
                        >
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld"
                            >Definir como recomendado<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div
                        class="form-input"
                        style="
                            display: flex;
                            flex-wrap: wrap;
                            gap: 10px;
                            align-items: center;
                        "
                    >
                        <CustomToggle v-model="recomendado" />
                        <small
                            >Um plano recomendado é tratado como principal na
                            tela de pagamento. Ative como recomendado e o Plano
                            terá mais destaque.</small
                        >
                    </div>
                </div>

                <div
                    class="col-12 col-md-8 offset-md-2 py-3 p-md-4"
                    v-if="valorPlanoFormatado && false"
                >
                    <div class="paymentMethods">
                        <div class="creditCard">
                            <img src="@/assets/Weflix/cartao.png" />
                            <div class="infoCreditCard">
                                <h4>Cartão de Crédito</h4>
                                <p>
                                    Seus clientes poderão pagar
                                    <strong style="color: #160266"
                                        >R${{
                                            formatarNumero(valorPlanoFormatado)
                                        }}</strong
                                    >
                                    {{
                                        valorPlanoFormatado >= 50
                                            ? 'parcelados em até '
                                            : 'em 1x'
                                    }}
                                    <strong
                                        v-if="valorPlanoFormatado >= 50"
                                        style="color: #160266"
                                    >
                                        {{
                                            Math.floor(
                                                valorPlanoFormatado / 50
                                            )
                                        }}x
                                    </strong>
                                    <span v-if="valorPlanoFormatado >= 50"
                                        >de</span
                                    >
                                    <strong
                                        v-if="valorPlanoFormatado >= 50"
                                        style="color: #160266"
                                    >
                                        R$
                                        {{
                                            (
                                                valorPlanoFormatado /
                                                Math.floor(
                                                    valorPlanoFormatado / 50
                                                )
                                            ).toFixed(2)
                                        }}
                                    </strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div :class="layout === 'modal' ? 'plan-modal__footer' : 'd-flex align-items-center justify-content-center justify-content-md-end ga-3 mt-5 mt-md-7'">
            <v-btn
                :variant="layout === 'modal' ? 'flat' : 'outlined'"
                :color="layout === 'modal' ? undefined : 'primary'"
                :class="layout === 'modal' ? 'plan-modal__button plan-modal__button--cancel' : ''"
                :size="layout === 'modal' ? undefined : ($vuetify.display.xs ? 'default' : 'large')"
                :disabled="saving"
                @click="onCancel"
            >
                {{ layout === 'modal' ? 'Cancelar' : 'Voltar' }}
            </v-btn>
            <v-btn
                :variant="'flat'"
                :color="layout === 'modal' ? undefined : 'primary'"
                :class="layout === 'modal' ? 'plan-modal__button plan-modal__button--save' : ''"
                :size="layout === 'modal' ? undefined : ($vuetify.display.xs ? 'default' : 'large')"
                :loading="saving"
                :disabled="saving"
                @click="createPlan"
            >
                {{ layout === 'modal' ? 'Salvar Plano' : 'Salvar' }}
            </v-btn>
        </div>
    </div>
</template>

<script>
    import Plans from '@/utils/Weflix/plan';
    import { mapState } from 'vuex';
    import { toast } from 'vue3-toastify';
    import CustomToggle from '@/components/Form/CustomToggle.vue';

    export default {
        name: 'NewPlanForm',
        components: {
            CustomToggle,
        },
        emits: ['success', 'cancel', 'saving-change'],
        props: {
            layout: {
                type: String,
                default: 'page',
                validator: (v) => ['page', 'modal'].includes(v),
            },
            /** Oculta título/subtítulo/divider (ex.: cabeçalho no v-dialog pai) */
            hideHeading: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                saving: false,
                nomePlano: '',
                valorPlano: '',
                valorPlanoFormatado: '',
                frequenciaRenovacao: '',
                recomendado: false,
                habilitarBoleto: false,
                habilitarPix: false,
            };
        },
        watch: {
            saving(val) {
                this.$emit('saving-change', val);
            },
        },
        computed: {
            ...mapState(['token']),
            rootClass() {
                if (this.layout === 'modal') {
                    return 'new-plan-form new-plan-form--modal text-left';
                }
                return 'container-fluid text-left page-card admin-weflix-newPlan d-flex flex-column flex-grow-1';
            },
            headingTag() {
                return this.layout === 'modal' ? 'h2' : 'h1';
            },
            titleText() {
                return 'Novo Plano';
            },
        },
        methods: {
            resetForm() {
                this.nomePlano = '';
                this.valorPlano = '';
                this.valorPlanoFormatado = '';
                this.frequenciaRenovacao = '';
                this.recomendado = false;
                this.saving = false;
            },
            onCancel() {
                this.$emit('cancel');
            },
            formatarValor() {
                let numeroLimpo = this.valorPlano.replace(/[^\d]/g, '');
                let valorFormatado = (parseFloat(numeroLimpo) / 100).toFixed(2);
                this.valorPlanoFormatado = valorFormatado.replace('.', '.');
                this.valorPlano = valorFormatado.replace(',', '.');
            },
            formatarNumero(numero) {
                let number = parseFloat(numero).toFixed(2);
                return number.replace('.', ',');
            },
            async createPlan() {
                const payload = {
                    name: this.nomePlano,
                    planValue: parseFloat(this.valorPlano),
                    planType: Number(this.frequenciaRenovacao),
                    recommended: this.recomendado ? 1 : 0,
                    card: 1,
                    billet: this.habilitarBoleto ? 1 : 0,
                    pix: this.habilitarPix ? 1 : 0,
                    discount: 0,
                    status: 1,
                };
                this.saving = true;
                try {
                    await Plans.createPlan(this.token, payload);
                    this.$emit('success');
                } catch (error) {
                    this.notify(
                        'Erro ao criar plano. Verifique os dados e tente novamente.',
                        'error'
                    );
                    console.error('Erro ao criar plano:', error);
                } finally {
                    this.saving = false;
                }
            },
            notify(message, type = 'info') {
                toast(message, {
                    autoClose: 3000,
                    position: 'top-right',
                    theme: 'light',
                    limit: 1,
                    type: type,
                    dangerouslyHTMLString: true,
                });
            },
        },
    };
</script>

<style scoped>
    @import '@/Views/Weflix/Adm/global.css';

    .admin-weflix-newPlan,
    .new-plan-form--modal {
        height: 100%;
        position: relative;
    }

    .new-plan-form--modal .card-title {
        font-size: 1.25rem;
        font-weight: 700;
    }

    .creditCard {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        text-align: left;
        gap: 21px;
    }

    .infoCreditCard h4 {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
    }

    .infoCreditCard {
        width: 80%;
    }

    .infoCreditCard p {
        margin: 0;
        color: gray;
    }

    .form-control:disabled {
        cursor: not-allowed;
        background-color: #f0f0f0;
    }

    @media (max-width: 600px) {
        .admin-weflix-newPlan h1,
        .new-plan-form--modal h2 {
            font-size: 20px;
            margin-bottom: 5px;
        }

        .admin-weflix-newPlan .card-subtitle,
        .new-plan-form--modal .card-subtitle {
            font-size: 12px;
            color: #666;
        }
    }
</style>
